import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import useAuth from '../../../Hooks/useAuth';
import { H6, Image, LI, P, UL } from '../../../AbstractElements';
import { settingIconData } from '../../../Data/Layout/RightHeader';
import SvgIcon from '../../../Utils/CommonComponents/CommonSvgIcons';

export default function UserWrap() {
   const [open, setOpen] = useState(false);
   const dropdownRef = useRef<HTMLLIElement | null>(null);

   const { logout, user, roles } = useAuth();

   const toggle = () => {
      setOpen((prevState) => !prevState);
   };

   useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
         if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target as Node)
         ) {
            setOpen(false);
         }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
         document.removeEventListener('mousedown', handleClickOutside);
      };
   }, []);

   const handleItemClick = () => {
      setOpen(false);
   };

   const avatarImg = `https://ui-avatars.com/api/?name=${user?.name}.svg`;

   return (
      <li className="profile-nav custom-dropdown" ref={dropdownRef}>
         <div className="user-wrap" onClick={toggle}>
            <div className="user-img">
               <Image src={avatarImg} alt="user" />
            </div>
            <div className="user-content">
               {/*<H6>{`${user?.name} ${user?.lastName}`}</H6>*/}
               <H6>{`${user?.name.toUpperCase()} (${user?.userName})`}</H6>
               <P className="mb-0">
                  {roles
                     ?.map((role: { displayName: string }) => role.displayName)
                     .join(', ')}
                  <i className="fa-solid fa-chevron-down" />
               </P>
            </div>
         </div>
         <div className={`custom-menu overflow-hidden ${open ? 'show' : ''}`}>
            <UL className="profile-body simple-list">
               {settingIconData.map((item) => (
                  <LI
                     className="d-flex"
                     key={item.id}
                     onClick={handleItemClick}
                  >
                     <SvgIcon className="svg-color" iconId={item.icon} />
                     <Link
                        className="ms-2"
                        to={`${process.env.PUBLIC_URL}/${item.link}`}
                     >
                        {item.text}
                     </Link>
                  </LI>
               ))}
               <LI
                  className="d-flex"
                  onClick={() => {
                     handleItemClick();
                     logout();
                  }}
               >
                  <SvgIcon className="svg-color" iconId="Login" />
                  <Link className="ms-2" to={`${process.env.PUBLIC_URL}/login`}>
                     Cerrar sesión
                  </Link>
               </LI>
            </UL>
         </div>
      </li>
   );
}
